(() => {
  if (window.__iftaCards) return;
  window.__iftaCards = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const setCount = (n) => document.querySelectorAll('[data-ifta-count]').forEach((c) => { c.dataset.n = n; c.textContent = n > 0 ? n : ''; });
  const refreshCount = async () => { try { const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); setCount(c.item_count); return c; } catch (e) { return null; } };
  const openDrawer = () => {
    const d = document.querySelector('theme-drawer#cart-drawer, #cart-drawer');
    if (d && typeof d.open === 'function') d.open();
    else if (d && typeof d.showDialog === 'function') d.showDialog();
    else location.href = root + 'cart';
  };
  document.addEventListener('cart:update', () => setTimeout(refreshCount, 200));
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-ifta-cart]')) { e.preventDefault(); openDrawer(); return; }
    const btn = e.target.closest('[data-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    const tx = btn.querySelector('[data-l]') || btn;
    const label = tx.textContent;
    tx.textContent = 'Adding…';
    btn.classList.add('is-busy');
    try {
      const id = Number(btn.dataset.id);
      if (!Number.isInteger(id) || id <= 0) throw new Error('Try again');
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer-section', sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add');
      const html = data.sections && data.sections['cart-drawer-section'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.cart-drawer__inner');
        const old = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && old) old.replaceWith(fresh);
      }
      const cart = await refreshCount();
      if (cart) document.querySelectorAll('cart-icon').forEach((c) => c.renderCartBubble && c.renderCartBubble(cart.item_count));
      openDrawer();
      tx.textContent = 'Added ✓';
      btn.classList.add('is-done');
    } catch (err) {
      tx.textContent = err.message && err.message.length < 28 ? err.message : 'Try again';
    }
    btn.classList.remove('is-busy');
    setTimeout(() => { tx.textContent = label; btn.disabled = false; btn.classList.remove('is-done'); }, 1800);
  });
})();